module.exports = __webpack_public_path__ + "d7e66efc10f50f81573c5c462fe5f98f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/category-totals.png
// module id = 1413
// module chunks = 0